import ErrorPage from './ErrorPage';

interface ServerErrorProps {
  onRetry: () => void;
  relative?: boolean;
}

const ServerError: React.FC<ServerErrorProps> = ({ onRetry, relative = false }) => (
  <ErrorPage
    title="serverErrorTitle"
    description="serverErrorDescription"
    imageSrc={`${process.env.PUBLIC_URL}/assets/images/error.svg`}
    onRetry={onRetry}
    relative={relative}
  />
);

export default ServerError;
